module.exports = __webpack_public_path__ + "img/transfersmile_big_logo.72adca4d.png";